// @flow

import type { BankOfferStatus } from "../../data/types/bankOffers";
import type { InquiryStatus } from "../../data/types/inquiries";

export const tabsCustomer: { title: string, id: BankOfferStatus }[] = [
  { title: "Neu", id: "new" },
  { title: "In Bearbeitung", amount: 0, id: "in_progress" },
  { title: "Angebot abgegeben", amount: 0, id: "offer_submitted" },
  { title: "Geschlossen", amount: 0, id: "closed" }
];

export const tabsBankAdvisor: { title: string, id: InquiryStatus }[] = [
  { title: "Neu", id: "new_for_bank" },
  { title: "In Bearbeitung", amount: 0, id: "processed_by_bank" },
  { title: "Geschlossen", amount: 0, id: "closed_for_bank" }
];

export const tabsBankAdvisorV2: { title: string, id: InquiryStatus }[] = [
  { title: "Neu", id: "new" },
  { title: "In Bearbeitung", amount: 0, id: "in_progress" },
  { title: "Geschlossen", amount: 0, id: "closed" }
];
